import { render, staticRenderFns } from "./TheCategoriesTitle.vue?vue&type=template&id=b1e2ae26&"
import script from "./TheCategoriesTitle.vue?vue&type=script&lang=js&"
export * from "./TheCategoriesTitle.vue?vue&type=script&lang=js&"
import style0 from "./TheCategoriesTitle.vue?vue&type=style&index=0&id=b1e2ae26&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports